export const adaptPlanCuidadoDuracionFase = (planCuidadoDuracionFaseData) => {
    return {
        id: planCuidadoDuracionFaseData?.idPlanCuidadoDuracionFase,
        displayName: planCuidadoDuracionFaseData?.descripcion,
        name: planCuidadoDuracionFaseData?.descripcion,
        duration: planCuidadoDuracionFaseData?.duracion,
    }
}

export const adaptPlanCuidadoDuracionFaseArray = (
    planCuidadoDuracionFases
) => {
    return structuredClone(planCuidadoDuracionFases?.allPlanCuidadoDuracionFase)
        ?.map(planCuidadoDuracionFase => adaptPlanCuidadoDuracionFase(planCuidadoDuracionFase));
}